export const getProperName = (fullName: string) => {
  const [lastName, firstName] = fullName.split(', ');
  return firstName ? `${firstName} ${lastName}` : fullName;
};
